import { useSearchParams } from 'react-router-dom';
import { queryLetter } from '../configs';
import { useEffect } from 'react';
import { dlSearchEvent } from '../../events/search/dl.search.event';
import { useAlgoliaDataContext } from '../hooks/useAlgoliaDataContext';
let prevQuery = '';
export const DLSearchEvent = () => {
    const [searchParams] = useSearchParams();
    const { queryID, nbHits } = useAlgoliaDataContext();
    const query = searchParams.get(queryLetter);
    useEffect(() => {
        if (queryID === undefined || queryID.length < 1 || prevQuery === query)
            return;
        window.dataLayer.push({
            page_context: {
                search_term: query ?? '',
                number_of_items: nbHits
            }
        });
        dlSearchEvent({
            query: query ?? '',
            nbHits
        });
        prevQuery = query;
    }, [queryID]);
    return null;
};
